import React from 'react'
import {
  TRACK_NESTING,
  TRACK_NESTING_EXPORT,
} from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import DataManagement from './DataManagement'
type Props = {
  children: React.ReactNode
}

const DataManagementContainer = ({ children }: Props): React.ReactNode => {
  const nestingExportEnabled: boolean = useFeatureEnabled(TRACK_NESTING_EXPORT)
  const nestingEnabled: boolean = useFeatureEnabled(TRACK_NESTING)
  return (
    <DataManagement
      isNestingExportEnabled={nestingExportEnabled && nestingEnabled}
    >
      {children}
    </DataManagement>
  )
}

export { default as DataManagementNesting } from './nesting'
export default DataManagementContainer
